import { Stack } from '@mui/material';
import { type ReactNode } from 'react';
import { matchPath, useLocation } from 'react-router-dom';

import { isDefined } from 'common';

import { useAgenticChatContext } from '../AgenticChat/context';

interface NavigationMainProps {
  children: ReactNode;
}

export function NavigationMain(props: NavigationMainProps) {
  const { children } = props;
  const { agenticChatVisibility, viewMode } = useAgenticChatContext();
  const location = useLocation();
  const isChatCoveringPage = agenticChatVisibility === 'Open' && viewMode === 'Fullscreen';

  return (
    <Stack
      component="main"
      aria-hidden={isChatCoveringPage}
      inert={isChatCoveringPage}
      flex={1}
      minWidth={0}
      direction="column"
      sx={{
        position: 'relative',
        // Keep fixed page panels beside the chat.
        contain:
          agenticChatVisibility === 'Open' &&
          viewMode === 'Sidebar' &&
          isDefined(
            matchPath(location.pathname, {
              path: [
                '/agents/flows/:flowId/definitions/:flowDefinitionId',
                '/agents/flows/:flowId/runs/:flowRunId',
                '/agents/flows/:flowId/explore-runs',
                '/human-tasks/:humanTaskId',
              ],
              exact: true,
            })
          )
            ? 'layout'
            : 'none',
        zIndex: 0,
        overflow: 'auto',
        visibility: isChatCoveringPage ? 'hidden' : 'visible',
      }}
    >
      {children}
    </Stack>
  );
}
